import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import { TokenService } from './services/storage.service';
import ApiService from './services/api.service';


Vue.config.productionTip = false;

// Set the base URL of the API
ApiService.init('https://api.belgoogroup.com/api/v1') //TODO:process.env.VUE_APP_ROOT_API)

// If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeader()
}

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
